import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: false,
    skuopen: false,
    stickyopen:false,
    datepickeropen: false,
    colorpickeropen: false,
    washpickeropen: false,
    label: "",
    datelabel: "",
    multiple: false,
    rowmode: false,      //TAG以外でmultiple=trueの場合rowmode=trueは「挿入」「上書」owmode=falseは「適用」
    data: null,
    datedata: null,
    rowid: [],           //Source Grid Select Rows
    currowid:'',        //Source Grid Click Row
    taglist: [],
    insearchtag: [],
    doApply: null,
    datedoApply: null,
    exdataid: "",         //サブテーブルの新規登録時主キーID
    rowdata:null,        //呼出元行データ
    layouts: [{ value: ' ', label: '既定レイアウト' }],
    prelayout: true,
    initlayout: ' ',
    showlimit:'2',
    fitColumn: false,
    useSearchPanel:false,
    gridApi: null,
    columninfo:[]
};

const searchlistSlice = createSlice({
    name: 'searchlist',
    initialState,
    reducers: {
        searchlistopen: (state, action) => {
            return Object.assign({}, state, {
                open: true, label: action.payload.label, multiple: action.payload.multiple, rowmode: action.payload.rowmode,
                data: action.payload.data, rowid: action.payload.rowid, currowid: action.payload.currowid, taglist: action.payload.taglist,
                doApply: action.payload.doApply, exdataid: action.payload.exdataid, rowdata: action.payload.rowdata, gridApi: action.payload.gridApi
            })
        },
        searchskuopen: (state, action) => {
            return Object.assign({}, state, {
                skuopen: true, label: action.payload.label,
                data: action.payload.data, rowid: action.payload.rowid, currowid: action.payload.currowid, columninfo:action.payload.columninfo,
                doApply: action.payload.doApply, rowdata: action.payload.rowdata, gridApi: action.payload.gridApi
            })
        },
        stickysearchopen: (state, action) => {
            return Object.assign({}, state, {
                stickyopen: true, label: action.payload.label, 
                data: action.payload.data, rowid: action.payload.rowid, 
                doApply: action.payload.doApply, gridApi: action.payload.gridApi
            })
        },
        datepickeropen: (state, action) => {
            return Object.assign({}, state, {
                datepickeropen: true, datelabel: action.payload.label,
                datedata: action.payload.data, rowid: action.payload.rowid,
                datedoApply: action.payload.doApply, gridApi: action.payload.gridApi
            })
        },
        colorpickeropen: (state, action) => {
            return Object.assign({}, state, {
                colorpickeropen: true, label: action.payload.label,
                data: action.payload.data, rowid: action.payload.rowid,
                doApply: action.payload.doApply, gridApi: action.payload.gridApi
            })
        },
        washpickeropen: (state, action) => {
            return Object.assign({}, state, {
                washpickeropen: true,
                rowid: action.payload.rowid,
                doApply: action.payload.doApply, gridApi: action.payload.gridApi
            })
        },
      setsearchtag: (state, action) => {
            return Object.assign({}, state, {
                insearchtag:  action.payload
            })
        },
        setsearchtoolpanel: (state, action) => {
            return Object.assign({}, state, {
                layouts: action.payload.layouts,
                prelayout: action.payload.prelayout,
                initlayout: action.payload.initlayout,
                showlimit: action.payload.showlimit,
                fitColumn: action.payload.fitColumn,
                useSearchPanel: action.payload.useSearchPanel,
            })
        },
        setsearchlayout: (state, action) => {
            return Object.assign({}, state, {
                layouts: action.payload
            })
        },
        setsearchdata: (state, action) => {
            return Object.assign({}, state, {
                data: action.payload
            })
        },
        setsearchstartup: (state, action) => {
            return Object.assign({}, state, {
                prelayout: action.payload.prelayout,
                initlayout: action.payload.initlayout,
                showlimit: action.payload.showlimit,
                fitColumn: action.payload.fitColumn
            })
        },
        searchaddlayout: (state, action) => {
            state.layouts.push(action.payload);
        },
        datepickerclose: (state, action) => {
            return Object.assign({}, state, {
                datepickeropen: false
            })
        },
       searchlistclose: (state, action) => {
            return initialState
        }
    },
});

export const {
    searchlistopen, stickysearchopen, datepickeropen, colorpickeropen, washpickeropen, searchskuopen, datepickerclose,
    setsearchtag, setsearchtoolpanel, searchaddlayout, setsearchlayout, setsearchdata, setsearchstartup, searchlistclose
} = searchlistSlice.actions

export default searchlistSlice;

